import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'

const CombustaoMovel = (props) => {

    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const [resultado, setResultado] = useState()




    async function carregaDados() {

        await api.get(`GHG_ViagensNegocios1/${adesao_institucional_id}/${ano}`).then((result) => {

            

            setResultado(result.data.map((rs) =>
            
                <tr>
                    <td><center>{rs.distanciaKm}</center></td>
                    <td><center>{rs.trechosVoados}</center></td>
                    <td><center>{rs.distanciaTotalKm}</center></td>
                    <td><center>{rs.emissoesCO2}</center></td>
                    <td><center>{rs.emissoesCH4}</center></td>
                    <td><center>{rs.emissoesN2O}</center></td>
                    <td><center>{rs.emissoesTotaisCO2e}</center></td>
                    
                    
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()

    }, [adesao_institucional_id, ano])



    useEffect(() => {


        //dataTableRender('dataTableExampleClima')


    }, [])


    return (

        <div>

            
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                          
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Distância Km
                                </center>

                            </th>
                        
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Trechos voados
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Distância total Km
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CO<sup>2</sup>
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CH<sup>4</sup>
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes N<sup>2</sup>O
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes Totais CO<sup>2</sup>E
                                </center>

                            </th>
                          
                            

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultado}
                    </tbody>
                    
                </table>    



        </div>
    )

}


export default CombustaoMovel